<div class="search-inside">
  <h1 class="mat-h2">Generar mapa curricular</h1>
  <p class="body-1">Seleccione por lo menos un curso o materia para generar el mapa curricular</p>
  <form [formGroup]="paramsForm">
    <!--<mat-form-field>
      <input matInput formControlName="termino">

    </mat-form-field>-->
    <mat-form-field appearance="outline" class="full-width">
      <mat-select placeholder="Seleccione curso" formControlName="idsCurso" multiple>
        <mat-option *ngFor="let curso of cursos" [value]="curso.id.toString()">{{curso.nombre}}</mat-option>
      </mat-select>
      <!--<mat-error *ngIf="animalControl.hasError('required')">Please choose an animal</mat-error>-->
      <!--<mat-hint>{{animalControl.value?.sound}}</mat-hint>-->
    </mat-form-field>
    <mat-form-field appearance="outline" class="full-width">
      <mat-select placeholder="Seleccione materia" formControlName="idsMateria" multiple>
        <mat-optgroup *ngFor="let area of areas" [label]="area.nombre">
          <mat-option *ngFor="let materia of area.materias" [value]="materia.id.toString()">
            {{materia.nombre}} <span class="font-sub2">({{area.nickName}})</span>
          </mat-option>
        </mat-optgroup>
      </mat-select>
      <!--<mat-error *ngIf="animalControl.hasError('required')">Please choose an animal</mat-error>-->
      <!--<mat-hint>{{animalControl.value?.sound}}</mat-hint>-->
    </mat-form-field>
    <div class="formButtons">
      <button mat-raised-button color="primary" (click)="realizarBusqueda()">Buscar</button>
      <a mat-button routerLink="." color="basic" (click)="cerrar($event)" skipLocationChange>Cerrar</a>
    </div>
  </form>
</div>
